import React, { FC, createContext, useState, useMemo } from 'react'

import {
  ISizeProps,
} from '../types/page'

import withScreenSize from '../hooks/withScreenSize'
import withScreenResize from '../hooks/withScreenResize'

import {
  BOWIE_SSH_IMAGE_SIZE_MIN,
  BOWIE_SSH_IMAGE_SIZE_MAX,
  BOWIE_WIDE_PAGE_SIZE_MIN,
} from '@shared/constants'

export interface ILayoutContext {
  sizeProps: ISizeProps,
  imageSize: number,
  containerSize: number,
  imageSizeElements: Record<string, HTMLElement>,
  setImageSizeElement: {
    (name: string, value: HTMLDivElement): void,
  }
}

export const LayoutContext = createContext<ILayoutContext>({
  sizeProps: {
    headline: 'h4',
    largeHeader: 'h5',
    header: 'h6',
    smallHeader: 'subtitle2',
    body: 'body1'
  },
  imageSize: 0,
  containerSize: 0,
  imageSizeElements: {},
  setImageSizeElement: (name: string, value: any) => {},
})

export const LayoutProvider: FC = ({
  children,
}) => {
  
  const windowSize = withScreenResize()

  const {
    screenSize,
  } = withScreenSize()

  const [ imageSizeElements, setImageSizeElements ] = useState<Record<string, HTMLElement>>({})

  const setImageSizeElement = (name: string, value: HTMLElement) => {
    setImageSizeElements(Object.assign({}, imageSizeElements, {
      [name]: value
    }))
  }

  const imageSize = useMemo(() => {
    if(!windowSize.height) return 0
    //if(!imageSizeElements.headline) return 0
    const headlineHeight = imageSizeElements.headline ? 
      imageSizeElements.headline.offsetHeight :
      60
    const heightCandidate = windowSize.height - headlineHeight - 36
    const widthCandidate = windowSize.width - 40
    let size = heightCandidate > widthCandidate ?
      widthCandidate :
      heightCandidate
    if(windowSize.width > windowSize.height && size < BOWIE_WIDE_PAGE_SIZE_MIN) {
      size = BOWIE_WIDE_PAGE_SIZE_MIN
    }
    size = size > BOWIE_SSH_IMAGE_SIZE_MAX ? BOWIE_SSH_IMAGE_SIZE_MAX : size
    size = size < BOWIE_SSH_IMAGE_SIZE_MIN ? BOWIE_SSH_IMAGE_SIZE_MIN : size
    return size
  }, [
    windowSize,
    imageSizeElements,
  ])

  const containerSize = useMemo(() => {
    return imageSize
  }, [
    windowSize,
    imageSize,
  ])

  const sizeProps = useMemo<ISizeProps>(() => {
    if(screenSize == 'large') {
      return {
        headline: 'h5',
        largeHeader: 'h5',
        header: 'h6',
        smallHeader: 'h6',
        body: 'body1'
      }
    }
    else if(screenSize == 'medium') {
      return {
        headline: 'h5',
        largeHeader: 'h5',
        header: 'h6',
        smallHeader: 'subtitle1',
        body: 'body1'
      }
    }
    else {
      return {
        headline: 'h5',
        largeHeader: 'h5',
        header: 'h6',
        smallHeader: 'subtitle2',
        body: 'body2'
      }
    }
  }, [
    screenSize,
  ])

  return (
    <LayoutContext.Provider value={{
      sizeProps,
      imageSize,
      containerSize,
      imageSizeElements,
      setImageSizeElement,
    }}>
      { children }
    </LayoutContext.Provider>
  )
}

export default LayoutContext